import React, { useCallback } from 'react';
import noop from 'lodash/noop';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Box, Stack, Typography } from '@lyearn/ui';
import { Image } from '@/components/Image';

import { CardProps } from './types';

const Card: React.FC<CardProps> = (props) => {
  const { content, disabled = false, onClick } = props;

  const { t } = useTranslation();

  const cursorClassName = content.disabled ? 'cursor-not-allowed' : 'cursor-pointer';

  const onCardClick = useCallback(() => {
    onClick(content.type);
  }, [content.type, onClick]);

  return (
    <Stack
      alignItems="center"
      className={cn(
        'mt-12 h-80 w-full rounded-8 border border-border bg-bg-primary',
        cursorClassName,
      )}
      data-attr={content.type}
      onClick={disabled ? noop : onCardClick}>
      <Box className="h-64 w-80 rounded-4 border border-border ms-10">
        {content.picture ? (
          <Image
            alt={content.title}
            className="h-full w-full rounded-4"
            height={64}
            src={content.picture}
            width={80}
          />
        ) : (
          <Stack
            alignItems="center"
            className="h-full w-full rounded-4 bg-interactive-white-active"
            justifyContent="center">
            <Typography className="rounded-4" variant="label-01">
              {t('Common:Design.Light')}
            </Typography>
          </Stack>
        )}
      </Box>
      <Stack className="mx-16 flex-1" direction="col">
        <Typography className="mb-4" color="text-text-primary" variant="heading-xxs">
          {content.title}
        </Typography>
        <Typography color="text-text-secondary" variant="body-short-03">
          {content.description}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default Card;
